import { Box, Grid2, Typography, IconButton, CircularProgress, Backdrop } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { React, CustomButton, AppLayout, useApi, Toaster, CustomBackdrop } from "../../utils/globalImports";
import { useState, useEffect, useRef } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CustomViewbaseLine from "./CustomViewbaseLine";
import {
    ProjectBaselineResponse,
    ProjectBaselineDetail,
    Proposal, Project,
    ProjectBaselineStatus,
    BaselineResponse,
    statusColors,
    ProjectBaselineDescriptions,
    BaselineProjectApproval,
    ProjectApprovalAction,
    ChangeDisplayType
} from "../../interfaces/baselineInterface";
import ProjectBaselineSummary from "./ProjectBaselineSummary";
import SummaryList from "./SummaryList";
import { buildSummaryRows } from "../../interfaces/summaryBuilder";

// Forecast Display Types
const ForecastDisplayType = {
    LiveDefinite: 1,
    LiveProposed: 2,
    ThirdPartyCost: 5,
};

interface BaseLineCustomForecastRef {
    triggerSave: () => Promise<boolean>;
}
interface ActiveMonthDetails{
  year:number,
  month:number,
  currentLockDate:Date,
  minAllowedDate:Date,
  maxAllowedDate:Date
}


const Viewbaseline: React.FC = () => {
    const location = useLocation();
    const role = localStorage.getItem("role");
    const isCommercial = role?.toLowerCase() === "commercial";
    const isSMT = role?.toLowerCase() === "smt";
    const currentBaselineId = location.state?.currentBaselineId ?? 0;
    const projectManagerID = location.state?.projectManagerID ?? 0;
    const isPreviousBaseLine = location.state?.isPreviousBaseLine ?? false;
    const { baselineMonth, baselineYear } = location.state;
    // const baselineDate = new Date(Number(baselineYear), Number(baselineMonth - 1), 1);
    const baselineDate = new Date(
        baselineYear,
        new Date(`${baselineMonth} 1, ${baselineYear}`).getMonth(),
        1
        );

    const [projects, setProjects] = useState<Project[]>([]);
    const [currentIndex, setCurrentIndex] = useState(-1);

    const [forecastType, setForecastType] = useState<number | null>(null);
    const [forecastData, setForecastData] = useState<Proposal[] | null>(null);
    const [currentBaseline, setCurrentBaseline] = useState<BaselineResponse | null>(null);
    const [pageLoading, setPageLoading] = useState(true);
    
    const [allBaselineData, setAllBaselineData] = useState<ProjectBaselineResponse | null>(null);
    const [allUpdatedRows, setAllUpdatedRows] = useState<ProjectBaselineDetail[]>([]);
    const [activeMonthDetails,setActiveMonthDetails]=useState<ActiveMonthDetails|null>(null);
        
    const { execute,loading } = useApi();
   
    const forecastRef = useRef<BaseLineCustomForecastRef | null>(null);    
    //   const monthName=currentDate.toLocaleString("default",{month:"short"})
    const monthName = activeMonthDetails
  ? new Date(
      activeMonthDetails.year,
      activeMonthDetails.month - 1,
      1
    ).toLocaleString("default", { month: "short" })
  : "";

const year = activeMonthDetails?.year ?? "";
    const userId = Number(localStorage.getItem("userId"));
    // ✅ Add this state near the top
    //const [projectApprovalStatus, setProjectApprovalStatus] = useState<Record<number, "Approved" | "Rejected" | null>>({});
    const [projectApprovalStatus, setProjectApprovalStatus] = useState<
        Record<number, ProjectApprovalAction>
    >({});
    const [isProcessing, setIsProcessing] = useState(false);
    const [toast, setToast] = useState({
        open: false,
        message: "",
        type: "success",
    });
    const [isSummaryClick, setSummaryClick] = useState(false);
    // Helper: format date (yyyy-MM-dd)

    
    const fetchActiveMonthDetails=async()=>{
        try {
      const {data} = await execute<ActiveMonthDetails>("get",`BaselineConfig/GetActiveMonthDetails`);
      setActiveMonthDetails(data)
        }
        catch(ex){
            console.log(ex)
        }
        
    }
    useEffect(() => {
        fetchActiveMonthDetails();
        const fetchAllBaselineData = async () => {
            try {

             
                
                const url = `/ProjectBaseline/GetProjectBaseLineAsync?baselineID=${currentBaselineId}&projectManagerID=${projectManagerID}`;
                const { data } = (await execute("get", url)) as { data: ProjectBaselineResponse };
                setAllBaselineData(data);
                setProjects(data.projects);
                if (data.projects.length > 0) {

                    // get the Current Baseline
                    const url = `/ProjectBaseline/${currentBaselineId}`;
                    const { data } = (await execute("get", url)) as { data: BaselineResponse };
                    setCurrentBaseline(data);
                    setCurrentIndex(0);
                    setPageLoading(false)
                }

            } catch (error: any) {
                if (error.name === "CanceledError") return;
                console.error("Error fetching all baseline data:", error);
            } finally {
               
            }

        };
        fetchAllBaselineData();
    }, []);

    useEffect(() => {
        setIsProcessing(false);
    }, [currentIndex]);

    // 🔄 Update forecastData when project or type changes
    useEffect(() => {

        if (!allBaselineData || !forecastType || !projects.length)
            return;

        const project = allBaselineData.projects?.find(
            (proj) => proj.projectId === projects[currentIndex].projectId
        );

        const projectProposals = {
            [ForecastDisplayType.LiveProposed]: project?.proposedProposals,
            [ForecastDisplayType.LiveDefinite]: project?.definiteProposals,
            [ForecastDisplayType.ThirdPartyCost]: project?.thridPartyProposals,

            // New: change versions
            [ChangeDisplayType.DefiniteChanges]: project?.definiteProposals,
            [ChangeDisplayType.ProposedChanges]: project?.proposedProposals,
            [ChangeDisplayType.ThirdPartyChanges]: project?.thridPartyProposals,
        }[forecastType] || [];

        setForecastData(projectProposals || []);
    }, [forecastType, currentIndex]);

    const handleSummaryClick = () => {
        if (!allBaselineData) return;
        console.log("view allBaselineData", allBaselineData)
        console.log("view allUpdatedRows", allUpdatedRows)
        const summaryRows = buildSummaryRows(allBaselineData, allUpdatedRows, ForecastDisplayType);
        console.log("view summaryRows", summaryRows)
        setAllUpdatedRows(summaryRows);
        setSummaryClick(true);
    };

    const handlebackToProjects = () => {
        setSummaryClick(false);
    }

    // 🔁 Navigation handlers
    const handleNext = () => {
        if (currentIndex < projects.length - 1) {
            setCurrentIndex((prev) => prev + 1);
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prev) => prev - 1);
        }
    };

    // ✅ Single function for Approve / Reject
    const handleApprovalAction = async (actionType: ProjectApprovalAction) => {
        try {
            if (!currentBaseline || currentIndex < 0 || !projects.length) return;
            setIsProcessing(true);
            const currentProject = projects[currentIndex];

            let commercialLeadStatus: number | null = null;
            let smtStatus: number | null = null;

            if (isCommercial) {
                commercialLeadStatus =
                    actionType === ProjectApprovalAction.Approved
                        ? ProjectBaselineStatus.ApprovedbyCommercialLead
                        : ProjectBaselineStatus.RejectedbyCommercialLead;
            } else if (isSMT) {
                smtStatus =
                    actionType === ProjectApprovalAction.Approved
                        ? ProjectBaselineStatus.ApprovedbySMT
                        : ProjectBaselineStatus.RejectedbySMT;
            }

            const payload: BaselineProjectApproval = {
                baselineID: currentBaseline.id,
                isSkipBL: false,
                isSkipCommercial: false,
                projectID: currentProject.projectId,
                isCommercialLead: isCommercial,
                commercialLeadId: userId,
                commercialLeadStatus: commercialLeadStatus,
                commercialLeadRemarks: "",
                smtStatus: smtStatus,
                smtRemarks: "",
                smtId: userId,
                commercialLeadUpdatedAt: null,
            };

            const url = "/ProjectBaseline/UpdateBaseline"; // ✅ replace with your actual API endpoint
            const response = (await execute("put", url, payload)) as {
                data?: {
                    success?: boolean;
                    message?: string;
                };
            };
            if (response?.data?.success) {
                setProjectApprovalStatus((prev) => ({
                    ...prev,
                    [currentProject.projectId]:
                        actionType === ProjectApprovalAction.Approved
                            ? ProjectApprovalAction.Approved
                            : ProjectApprovalAction.Rejected,
                }));

                // ✅ Update the local project status (instant UI change)
                setProjects((prevProjects) =>
                    prevProjects.map((proj) =>
                        proj.projectId === currentProject.projectId
                            ? {
                                ...proj,
                                status:
                                    isCommercial
                                        ? actionType === ProjectApprovalAction.Approved
                                            ? ProjectBaselineStatus.ApprovedbyCommercialLead
                                            : ProjectBaselineStatus.RejectedbyCommercialLead
                                        : isSMT
                                            ? actionType === ProjectApprovalAction.Approved
                                                ? ProjectBaselineStatus.ApprovedbySMT
                                                : ProjectBaselineStatus.RejectedbySMT
                                            : proj.status, // keep existing if no role match
                            }
                            : proj
                    )
                );
                setToast({
                    open: true,
                    message: `Project ${actionType === ProjectApprovalAction.Approved ? "Approved" : "Rejected"
                        } successfully!`,
                    type: "success",
                });
            } else {
                setIsProcessing(false);
                setToast({
                    open: true,
                    message: response?.data?.message || `Failed to ${actionType} project.`,
                    type: "error",
                });

            }
        } catch (error: any) {
            console.error(`❌ Error during ${actionType}:`, error);
            setIsProcessing(false);
            setToast({
                open: true,
                message: `Failed to ${actionType} project. ${error?.message || ""}`,
                type: "error",
            });;
        }
    };


    return (
        <AppLayout>
            {/* ===== Always Show Header Title ===== */}

            <Box >
                <Typography
                    variant="h6"
                    sx={{ color: "#1e66ab", fontWeight: "bold", mb: 1 }}
                >
                    View Baseline - {
                        isPreviousBaseLine
                            ? `${baselineMonth} ${baselineYear}`
                            : `${monthName} ${year}`
                    }
                </Typography>

                {currentBaseline && currentBaseline.id > 0 && (
                    <Typography variant="h6" sx={{ color: statusColors[currentBaseline.status], fontWeight: "bold", mb: 0 }}>
                        Baseline Status: {ProjectBaselineDescriptions[currentBaseline.status]}
                    </Typography>
                )}
                <Box
                    sx={{
                        backgroundColor: "#96c121",
                        height: "2px",
                        border: "none",
                        mb: 2,
                        
                    }}
                />
            </Box>


            {/* ===== Loading State ===== */}
            {loading ? (
                <Box
                    sx={{
                        
                        height: "70vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : allBaselineData && allBaselineData.projects?.length > 0 ? (
                // ✅ Render Baseline Data UI
                <Box
                    sx={{
                        height: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    {/* ===== Header Controls ===== */}
                    <Box
                        sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                            backgroundColor: "white",
                            borderBottom: "1px solid #ddd",
                            
                        }}
                    >
                        {/* Navigation */}
                        {!isSummaryClick && (
                            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                <IconButton
                                    onClick={handlePrevious}
                                    disabled={currentIndex === 0}
                                    sx={{
                                        color: "black",
                                        border: "2px solid black",
                                        borderRadius: "50%",
                                        mr: 1.5,
                                    }}
                                >
                                    <ArrowBackIcon />
                                </IconButton>

                                <Typography sx={{ fontSize: "25px", color: "#1e66ab", fontWeight: 600, ml: 0 }}>
                                    {projects[currentIndex]?.name || "No Project"}{" "}
                                    [
                                    <Box
                                        component="span"
                                        sx={{
                                            color: statusColors[projects[currentIndex]?.status] || "#000",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Status -  {ProjectBaselineDescriptions[projects[currentIndex]?.status]}
                                    </Box>
                                    ]
                                </Typography>

                                <IconButton
                                    onClick={handleNext}
                                    disabled={currentIndex === projects.length - 1}
                                    sx={{
                                        color: "black",
                                        border: "2px solid black",
                                        borderRadius: "50%",
                                        ml: 1.5,
                                    }}
                                >
                                    <ArrowForwardIcon />
                                </IconButton>
                            </Box>
                        )}
                        {/* Forecast Type Buttons */}
                        <Grid2
                            container
                            spacing={2}
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ mt: 0 }}
                        >
                            {/* Forecast Type Buttons + Approval Buttons */}
                            {!isSummaryClick && (
                                <>
                                    {/* Left: Forecast Type Buttons */}
                                    <Box sx={{ display: "flex", gap: 3, mt: 1 }}>
                                        {[
                                            ForecastDisplayType.LiveDefinite,
                                            ForecastDisplayType.LiveProposed,
                                            ForecastDisplayType.ThirdPartyCost,
                                        ].map((type) => (
                                            <CustomButton
                                                key={type}
                                                onClick={() => setForecastType(type)}
                                                backgroundColor={forecastType === type ? "#1e66ab" : "#f0f0f0"}
                                                sx={{
                                                    color: forecastType === type ? "white" : "#1e66ab",
                                                    textTransform: "none",
                                                    whiteSpace: "nowrap",
                                                    minWidth: "120px",
                                                    height: "38px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {type === ForecastDisplayType.LiveDefinite
                                                    ? "Definite"
                                                    : type === ForecastDisplayType.LiveProposed
                                                        ? "Proposed"
                                                        : "Third Party"}
                                            </CustomButton>
                                        ))}
                                        {/* NEW CHANGE BUTTONS */}
                                        {(isCommercial || isSMT) && (
                                            <>
                                                <CustomButton
                                                    onClick={() => setForecastType(ChangeDisplayType.DefiniteChanges)}
                                                    backgroundColor={forecastType === ChangeDisplayType.DefiniteChanges ? "#1e66ab" : "#f0f0f0"}
                                                    sx={{
                                                        color: forecastType === ChangeDisplayType.DefiniteChanges ? "white" : "#1e66ab",
                                                        textTransform: "none !important",
                                                        whiteSpace: "nowrap",
                                                        minWidth: "120px",
                                                        height: "38px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    Definite Changes
                                                </CustomButton>

                                                <CustomButton
                                                    onClick={() => setForecastType(ChangeDisplayType.ProposedChanges)}
                                                    backgroundColor={forecastType === ChangeDisplayType.ProposedChanges ? "#1e66ab" : "#f0f0f0"}
                                                    sx={{
                                                        color: forecastType === ChangeDisplayType.ProposedChanges ? "white" : "#1e66ab",
                                                        textTransform: "none !important",
                                                        whiteSpace: "nowrap",
                                                        minWidth: "130px",
                                                        height: "38px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    Proposed Changes
                                                </CustomButton>

                                                <CustomButton
                                                    onClick={() => setForecastType(ChangeDisplayType.ThirdPartyChanges)}
                                                    backgroundColor={forecastType === ChangeDisplayType.ThirdPartyChanges ? "#1e66ab" : "#f0f0f0"}
                                                    sx={{
                                                        textTransform: "none !important",
                                                        color: forecastType === ChangeDisplayType.ThirdPartyChanges ? "white" : "#1e66ab",
                                                        whiteSpace: "nowrap",
                                                        px: 3,
                                                        height: "38px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    Third Party Changes
                                                </CustomButton>
                                            </>
                                        )}
                                    </Box>

                                    {/* Right: Approve/Reject + Go to Summary */}
                                    <Box sx={{ display: "flex", gap: 2, alignItems: "center", ml: "auto" }}>
                                        {/* ✅ Approve/Reject Buttons */}
                                        {forecastType !== null &&
                                            ((isCommercial &&
                                                projects[currentIndex]?.status ===
                                                ProjectBaselineStatus.AwaitingReviewbyCommercialLead) ||
                                                (isSMT &&
                                                    [
                                                        ProjectBaselineStatus.SkipCommercial,
                                                        ProjectBaselineStatus.AwaitingReviewbyCommercialLead,
                                                        ProjectBaselineStatus.ApprovedbyCommercialLead,
                                                    ].includes(projects[currentIndex]?.status))) && (
                                                <>
                                                    <CustomButton
                                                        onClick={() => handleApprovalAction(ProjectApprovalAction.Approved)}
                                                        backgroundColor="#4CAF50"
                                                        disabled={
                                                            isProcessing ||
                                                            projectApprovalStatus[projects[currentIndex]?.projectId] ===
                                                            ProjectApprovalAction.Approved ||
                                                            projectApprovalStatus[projects[currentIndex]?.projectId] ===
                                                            ProjectApprovalAction.Rejected || isPreviousBaseLine
                                                        }
                                                        sx={{
                                                            color: "white",
                                                            px: 2.5,
                                                            py: 0.8,
                                                            fontWeight: "bold",
                                                            minWidth: "110px",
                                                            borderRadius: "8px",
                                                        }}
                                                    >
                                                        Approve
                                                    </CustomButton>

                                                    <CustomButton
                                                        onClick={() => handleApprovalAction(ProjectApprovalAction.Rejected)}
                                                        backgroundColor="#F44336"
                                                        disabled={
                                                            isProcessing ||
                                                            projectApprovalStatus[projects[currentIndex]?.projectId] ===
                                                            ProjectApprovalAction.Approved ||
                                                            projectApprovalStatus[projects[currentIndex]?.projectId] ===
                                                            ProjectApprovalAction.Rejected || isPreviousBaseLine
                                                        }
                                                        sx={{
                                                            color: "white",
                                                            px: 2.5,
                                                            py: 0.8,
                                                            fontWeight: "bold",
                                                            minWidth: "110px",
                                                            borderRadius: "8px",
                                                        }}
                                                    >
                                                        Reject
                                                    </CustomButton>
                                                </>
                                            )}

                                        {/* ✅ Go to Summary on last project */}
                                        {(isCommercial || isSMT) && currentIndex === projects.length - 1 && (
                                            <CustomButton
                                                //disabled={!forecastData}
                                                onClick={handleSummaryClick}
                                                backgroundColor="#1e66ab"
                                                sx={{
                                                    color: "white",
                                                    px: 2.5,
                                                    py: 0.8,
                                                    fontWeight: "bold",
                                                    minWidth: "150px",
                                                    borderRadius: "8px",
                                                    whiteSpace: "nowrap",
                                                    height: "38px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                Go to Summary
                                            </CustomButton>
                                        )}
                                    </Box>
                                </>
                            )}
                        </Grid2>

                        {isSummaryClick && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "left",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "left" }}>
                                    <IconButton
                                        onClick={handlebackToProjects}
                                        sx={{
                                            color: "black",
                                            border: "2px solid black",
                                            borderRadius: "50%",
                                            mr: 1.5,
                                        }}
                                    >
                                        <ArrowBackIcon />
                                    </IconButton>
                                    <Typography sx={{ fontSize: "25px", color: "#1e66ab", fontWeight: 600 }}>
                                        Baseline Summary – {monthName} {year}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                    </Box>

                    {/* ===== Scrollable Table Section ===== */}
                    <Box
                        sx={{
                            flex: 1,
                            //overflowY: "auto",
                            overflowY: isSummaryClick ? "" : "auto",
                            p: 0,
                            backgroundColor: "#fafafa",
                            position: "relative",
                        }}
                    >
                        {!isSummaryClick ? (
                            projects[currentIndex] ? (
                                forecastData && forecastType !== null ? (
                                    <CustomViewbaseLine
                                        ref={forecastRef}
                                        forecastData={forecastData}
                                        forecastType={forecastType}
                                    //    startDate ={projects[currentIndex]?.startDate}
                                        startDate={isPreviousBaseLine ? baselineDate: projects[currentIndex]?.startDate}
                                        endDate={projects[currentIndex]?.endDate}
                                        currentProjectID={projects[currentIndex].projectId}
                                        initialUpdatedRows={allUpdatedRows.filter(
                                            (r) => r.ProjectID === projects[currentIndex].projectId
                                        )}
                                        onUpdateRows={(updatedRowsForProject) => {
                                            setAllUpdatedRows((prev) => [
                                                ...prev.filter(
                                                    (r) =>
                                                        !updatedRowsForProject.some(
                                                            (u) =>
                                                                u.ProjectID === r.ProjectID &&
                                                                u.FeeStageID === r.FeeStageID &&
                                                                u.BaselineMonth === r.BaselineMonth
                                                        )
                                                ),
                                                ...updatedRowsForProject,
                                            ]);
                                        }}
                                        readOnly
                                    />
                                ) : (
                                    <Typography color="text.secondary">
                                        Select a forecast type to view data
                                    </Typography>
                                )
                            ) : (
                                <Typography>No project available</Typography>
                            )
                        ) : (
                            //<ProjectBaselineSummary baselineId={currentBaselineId} />
                            <SummaryList
                                baselineId={currentBaselineId}
                                allUpdatedRows={allUpdatedRows}
                                monthName={monthName}
                                year={Number(year)}
                                forecastType={forecastType ?? 0}
                            />
                            // <SummaryPages
                            //     baselineId={currentBaselineId}
                            //     allUpdatedRows={projects}
                            //     monthName={monthName}
                            //     year={year}
                            //     forecastType={forecastType??0}
                            // />
                        )}
                    </Box>

                </Box>
            ) : (
                // 🚫 No Baseline Data Message
                <Box
                    sx={{
                        height: "70vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography color="text.secondary">
                        No baseline data available for this month.
                    </Typography>

                </Box>

            )}
            <Toaster
                open={toast.open}
                message={toast.message}
                type={toast.type as "success" | "error"}
                onClose={() => setToast((prev) => ({ ...prev, open: false }))}
            />
           <CustomBackdrop open={pageLoading} />
        </AppLayout>
    );

};

export default Viewbaseline;
